import * as React from 'react';

import { Icon } from '../icon/icon.tsx';

import { useClickAway } from '../hooks.tsx';

import './context-menu.css';
import clsx from 'clsx';

interface ContextMenuProps extends React.HTMLAttributes<HTMLDivElement> {
  options: Array<{
    label: string;
    action: () => void;
    icon?: React.ReactNode;
    active?: boolean;
    disabled?: boolean;
    leadingIcon?: React.ReactNode;
    trailingIcon?: React.ReactNode;
  }>;
  iconDirection?: 'leading' | 'trailing';
  menuPosition?: {
    xOffset?: number;
    yOffset?: number;
    anchor?: 'top-left' | 'bottom-left' | 'top-right' | 'bottom-right';
    reference?: 'top-left' | 'bottom-left' | 'top-right' | 'bottom-right';
  };
  open?: boolean;
}

const ContextMenu = React.forwardRef<HTMLDivElement, ContextMenuProps>(
  ({ options, open = false, menuPosition, ...props }, ref) => {
    const [menuVisibility, setMenuVisibility] = React.useState(open);
    const menuRef = useClickAway(() => {
      setMenuVisibility(!menuVisibility);
    }, 'Icon more');

    const contextMenuPortalClasses = clsx('context-menu-portal', {
      [`context-menu-portal__anchor--${menuPosition?.anchor}`]:
        menuPosition?.anchor,
      [`context-menu-portal__reference--${menuPosition?.reference}`]:
        menuPosition?.reference,
    });

    return (
      <div className="context-menu" ref={ref} {...props}>
        <button
          type="button"
          className="context-menu-trigger"
          onClick={() => setMenuVisibility(!menuVisibility)}
        >
          <Icon
            type="more"
            size="large"
            className={`context-menu-trigger-icon ${
              menuVisibility && 'context-menu-trigger-icon-active'
            }`}
          />
        </button>
        {menuVisibility && (
          <div
            ref={menuRef}
            className={contextMenuPortalClasses}
            // style={{
            //   // @ts-expect-error it's the only way to bind data to a .css file
            //   '--context-menu-portal-menu-x': `${menuPosition.xOffset}px`,
            //   '--context-menu-portal-menu-y': `${menuPosition.yOffset}px`,
            // }}
          >
            {options.map(option => {
              return (
                <div key={option.label} className="context-menu-portal-option">
                  <button
                    type="button"
                    onClick={() => {
                      if (!option.disabled) {
                        option.action();
                        setMenuVisibility(!menuVisibility);
                      }
                    }}
                    className={`context-menu-portal-option-label${
                      option.disabled
                        ? '-disabled'
                        : option.active
                        ? '-active'
                        : ''
                    }`}
                  >
                    <div className="context-menu-portal-option-label-wrapper">
                      {option.leadingIcon && (
                        <div className="context-menu-portal-option-label-wrapper-leading-icon">
                          {option.leadingIcon}
                        </div>
                      )}
                      {option.label}
                    </div>
                    {option.trailingIcon && (
                      <div className="context-menu-portal-option-label-trailing-icon">
                        {option.trailingIcon}
                      </div>
                    )}
                  </button>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  },
);

export { ContextMenu };
